import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

import { candidatesApi } from 'api/candidates-api';

export const idUploadDetailsApi = createApi({
  reducerPath: 'idUploadDetailsApi',
  baseQuery: createBaseQuery('id_upload_details'),
  endpoints: builder => ({
    updateIdUploadDetail: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data: detail } = await queryFulfilled;
          const candidateId = detail?.candidate_id;
          if (candidateId != null) {
            dispatch(
              candidatesApi.util.invalidateTags([{ type: 'CandidateIdv', id: candidateId }]),
            );
          }
        } catch {
          // mutation failed
        }
      },
    }),
  }),
});

export const { useUpdateIdUploadDetailMutation } = idUploadDetailsApi;
